var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmmc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_6235)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 28.604,
    y: 17.7651,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 34.1299,
    y: 17.7651,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 23.0781,
    y: 17.7651,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 17.5513,
    y: 17.7656,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.604,
    y: 39.8687,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.0781,
    y: 39.8687,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5522,
    y: 39.8687,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 17.7651,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 34.3433,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 39.8687,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 28.8174,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 23.2915,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1299,
    y: 39.8687,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 21.6958,
    y: 28.8174,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(90 21.6958 28.8174)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 21.6958,
    y: 23.2915,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(90 21.6958 23.2915)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 21.6958,
    y: 34.3433,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(90 21.6958 34.3433)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 17.5522,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 23.0781,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 12.0264,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 6.5,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 28.604,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 39.6548,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 45.1816,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 34.1299,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 6.5,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5522,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.0781,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.0264,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.604,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6548,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.1299,
    y: 50.709,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.1816,
    y: 50.7075,
    width: 4.14443,
    height: 4.14443,
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 43.8003,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 43.8003)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 38.2739,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 38.2739)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 49.3257,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 49.3257)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.1938,
    y: 49.3257,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 45.1938 49.3257)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 54.8516,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 54.8516)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 32.748,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 32.748)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 21.6963,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 21.6963)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 16.1699,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 16.1699)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.707,
    y: 27.2227,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 50.707 27.2227)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 6.5,
    y: 43.8003,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 43.8003)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 6.5,
    y: 38.2739,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 38.2739)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 6.5,
    y: 49.3257,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 49.3257)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 6.5,
    y: 54.8516,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 54.8516)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 6.5,
    y: 32.748,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 32.748)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 6.5,
    y: 21.6963,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 21.6963)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 6.5,
    y: 16.1699,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 16.1699)",
    fill: "#00C7FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 6.5,
    y: 27.2227,
    width: 4.14443,
    height: 4.14443,
    transform: "rotate(-90 6.5 27.2227)",
    fill: "#00C7FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_6235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmmc);
export default __webpack_public_path__ + "static/media/emmc.63f49866c1a60979413e009bfc2d30a2.svg";
export { ForwardRef as ReactComponent };